export class Alive5Conversation {
  sender: string;
  receiver: string;
  messageContent: string;
  createdAt: string;
  attachmentURLs: string;
  phoneMobile: string;
  sentByNumber: string;
}
